import {
  Button,
  Fab,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from "@material-ui/core";
import { API, graphqlOperation } from "aws-amplify";
import MaterialTable from "material-table";
import React, { Fragment, useEffect, useState } from "react";
import MuiForm from "rjsf-material-ui";
import { DataPortalService, Role } from "../../api/DataPortalService";
import { v4 as uuidv4 } from "uuid";
import * as mutation from "../../api/graphql/mutations";
import * as query from "../../api/graphql/queries";
import AtlasPanel from "../../atlas/blades/AtlasPanel";
import { KeyValue } from "../../api/models";

const DatasetTags: React.FC<any> = ({ theme, dataset, role }) => {
  if (dataset === null) {
    return <Fragment />;
  }

  const [data, setData] = useState<Array<any>>([]);

  useEffect(() => {
    dataset.tags = dataset.tags || [];
    setData(dataset.tags.map((v) => Object.assign({}, v)));
  }, [dataset]);

  return (
    <MaterialTable
      title="Tags"
      columns={[
        { title: "Name", field: "key" },
        { title: "Value", field: "value" },
      ]}
      data={data}
      options={{
        showTitle: true,
        grouping: false,
        exportButton: false,
        columnsButton: false,
        search: false,
        pageSize: 5,
        pageSizeOptions: [],
        actionsColumnIndex: -1,
        headerStyle: {
          fontSize: "12px",
          fontWeight: "bold",
          padding: "3px 10px",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          zIndex: 0,
        },
        rowStyle: {
          fontSize: "13px",
        },
      }}
      editable={
        role === Role.ADMIN
          ? {
              onRowAdd: (tag) => {
                return DataPortalService.setDatasetTags(dataset, [
                  ...(dataset.tags || []),
                  tag,
                ]);
              },
              onRowUpdate: (newData, oldData) => {
                const index = oldData.tableData.id;
                dataset.tags[index] = {
                  key: newData.key,
                  value: newData.value,
                };
                return DataPortalService.setDatasetTags(dataset, dataset.tags);
              },
              onRowDelete: (oldData) => {
                const index = oldData.tableData.id;
                dataset.tags.splice(index, 1);
                return DataPortalService.setDatasetTags(dataset, dataset.tags);
              },
            }
          : {}
      }
    />
  );
};

export default DatasetTags;
